import React from 'react';

/* Utils. */
import classnames from 'classnames';

/* Styles */
import css from './nibCard.module.sass';

const NibCard = ({ children, className, title, subtitle, htmlId = false, style = {}, ...props }) => {
  return (
    <div
      id={htmlId ? htmlId : ''}
      className={classnames(css.cardWrap, className && className, 'ui-card')}
      style={{ ...style }}
      {...props}
    >
      {title && (
        <div className={classnames(css.header, 'ui-card-header')}>
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}
      <div className={classnames(css.card, 'ui-card-card')}>{children}</div>
    </div>
  );
};

export default NibCard;
